<template>
    <v-btn-toggle
            class="rounded-btn-group v-text-field--outline"
            mandatory 
            :value="selectedValue" 
            @change="handleValueChanged">
            <v-flex v-for="(option, index) in options" :key="index" class="pa-0" xs6>
                <v-btn flat block>
                    <span>{{ option.name }}</span>
                </v-btn>
            </v-flex>
    </v-btn-toggle>
</template>


<script>

export default {
    components: {

    },
    props: {
        value: {
            type: Number,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    },
    data(){
        return {

        };
    },
    computed: {
        selectedValue(){
            return Object.keys(this.options).findIndex(
                x => this.options[x].id === this.value
            );
        }
    },
    methods: {
        handleValueChanged(value){
            this.update(this.options[value].id);
        },
        update(value){
            this.$emit("input", value);
        }
    },
    created(){

    }
}
</script>

<style scoped>
.rounded-btn-group {
    border-radius: 4px;
    border: 2px solid rgba(0,0,0,0.54);
    margin-bottom: 0px;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.rounded-btn-group .v-btn {
    padding: 16px 20px;
    height: 56px;
    width: 100%;
}

.rounded-btn-group:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.rounded-btn-group:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
</style>